// Shared plugin: reload the page after 12 hours of tab inactivity
//
// Behaviour:
// - Starts tracking when the tab becomes hidden.
// - When the tab becomes visible again:
//   * If it has been hidden for more than 12 hours, the page is reloaded.
//   * Otherwise, the hidden timestamp is cleared and nothing happens.
//
// Notes:
// - The timestamp is kept only in memory so the check only applies
//   while the tab remains open. A full reload or new visit resets it.

const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000;

let hiddenAt: number | null = null;

function handleVisibilityChange() {
  if (document.visibilityState === "hidden") {
    hiddenAt = Date.now();
    return;
  }

  if (document.visibilityState === "visible" && hiddenAt !== null) {
    const now = Date.now();
    const diff = now - hiddenAt;

    if (diff > TWELVE_HOURS_MS) {
      // Reload the page after long inactivity
      window.location.reload();
    } else {
      // Less than 12 hours: just clear the timestamp
      hiddenAt = null;
    }
  }
}

// Guard for environments where document might not exist (SSR/tests)
if (typeof document !== "undefined" && typeof window !== "undefined") {
  document.addEventListener("visibilitychange", handleVisibilityChange);
}

